import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { Logo } from "@/components/brand/Logo";
import brand from "@/config/brand";

const LINK_GROUPS = [
  {
    title: "المنصة",
    items: [
      { label: "الفرص",           to: "/opportunities" },
      { label: "مكتبة المعرفة",   to: "/knowledge" },
      { label: "المحفوظات",        to: "/saved" },
    ],
  },
  {
    title: "الشركة",
    items: [
      { label: "عن فرصالوجيا", to: "/about" },
      { label: "تواصل معنا",  to: "/contact" },
    ],
  },
  {
    title: "القانوني",
    items: [
      { label: "سياسة الخصوصية", to: "/privacy" },
      { label: "شروط الاستخدام", to: "/terms" },
    ],
  },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid={FOOTER.root} className="border-t border-surface-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
        {/* Wordmark row */}
        <div className="flex flex-col gap-10 border-b border-surface-200 pb-10 md:flex-row md:items-start md:justify-between md:gap-16">
          <div className="max-w-md">
            <Link to="/" className="inline-flex items-center" aria-label="Fursalogia — الصفحة الرئيسية">
              <Logo variant="full" size="md" />
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-ink-500">
              {brand.footer.description}
            </p>
            <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-fursa-200 bg-fursa-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-widest text-fursa-700">
              <span className="h-1.5 w-1.5 rounded-full bg-fursa-600" aria-hidden />
              {brand.footer.betaLabel}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {LINK_GROUPS.map((group) => (
              <div key={group.title}>
                <p className="text-[10px] font-semibold uppercase tracking-widest text-ink-500">
                  {group.title}
                </p>
                <ul className="mt-4 space-y-2.5 text-sm">
                  {group.items.map((item) => (
                    <li key={item.label}>
                      <Link
                        to={item.to}
                        className="text-ink-700 transition-colors hover:text-fursa-700"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col-reverse items-start gap-4 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-ink-500">{brand.copyright(year)}</p>
          <div className="flex items-center gap-4">
            <p className="text-[11px] font-mono uppercase tracking-widest text-ink-500">
              {brand.footer.tagline}
            </p>
            {/* Discreet operator entry point — replaces the old public /admin link */}
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="text-[11px] font-medium text-ink-500 transition-colors hover:text-intel-800"
            >
              Admin →
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
